import React, {Dispatch, useState} from "react";
import {CareTeamListAction} from "./practitionerCareTeamListReducer";
import {PractitionerCareTeamRoleInput} from "./PractitionerCareTeamRoleInput";
import {PractitionerCareTeamInput} from "../domain";
import {FormProvider, useForm} from "react-hook-form";
import {PractitionerCareTeamStartDateInput} from "./PractitionerCareTeamStartDateInput";
import {PractitionerCareTeamEndDateInput} from "./PractitionerCareTeamEndDateInput";
import {FatOutlineButton} from "../../../common/component/FatOutlineButton";
import {PractitionerCareTeamClinicianInput} from "./PractitionerCareTeamClinicianInput";
import {SelectOption} from "../../../common";
import {Observable} from "rxjs";
import {useObservable} from "rxsupport";

type CreateNewCareTeamModalProps = {
    showModal: boolean,
    clientGuid: string,
    dispatch: Dispatch<CareTeamListAction>,
    submitOperation: (input: PractitionerCareTeamInput) => void | Promise<void>,
    isSubmitting$: Observable<boolean>
}

export function CreateNewCareTeamModal({
                                           showModal,
                                           dispatch,
                                           isSubmitting$,
                                           submitOperation
                                       }: CreateNewCareTeamModalProps) {
    const methods = useForm<PractitionerCareTeamInput>({
        defaultValues: {}
    });

    const [practitioners, setPractitioners] = useState<SelectOption[]>([]);
    const onSubmit = async (data: PractitionerCareTeamInput) => {
        await submitOperation(data)
        hideModal()
    }

    const sending = useObservable(isSubmitting$, false);

    const clearFormData = () => {
        methods.reset()
        setPractitioners([])
    }
    const hideModal = () => {
        if (sending) {
            return;
        }
        clearFormData();
        dispatch({type: 'SET_HIDE_NEW_MODAL'})
    }


    return (
        <div
            className={(showModal ? "" : "hidden ") + "overflow-y-auto overflow-x-hidden absolute z-50 justify-center items-center h-modal h-full inset-0"}
            style={{backgroundColor: "rgba(0,0,0,0.4)"}}>
            <div className="relative px-4 w-full max-w-4xl h-full md:h-auto"
                 style={{left: "50%", top: "50%", transform: "translate(-50%, -50%)"}}>
                <FormProvider {...methods}>
                    <form className="relative bg-white rounded-lg shadow dark:bg-gray-700"
                          autoComplete="off"
                          onSubmit={methods.handleSubmit(onSubmit)}>
                        <div className="flex justify-between items-start p-4 rounded-t border-b dark:border-gray-600">
                            <h3 className="text-base font-semibold text-gray-900 dark:text-white">
                                Add New Care Team Member
                            </h3>
                            <button type="button"
                                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                                    onClick={hideModal}
                            >
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd"
                                          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                          clipRule="evenodd"/>
                                </svg>
                            </button>
                        </div>
                        <div className="space-y-6">
                            <div className="flex flex-col w-full p-4">
                                <PractitionerCareTeamRoleInput sending={sending}/>
                                <PractitionerCareTeamStartDateInput sending={sending}/>
                                <PractitionerCareTeamEndDateInput sending={sending}/>
                                <PractitionerCareTeamClinicianInput
                                    sending={sending}
                                    practitioners={practitioners}
                                    setPractitioners={setPractitioners}
                                />
                            </div>
                        </div>

                        <div className="w-full flex border-t dark:border-gray-600 p-4 justify-end">
                            <div className="flex w-1/4">
                                <FatOutlineButton color={'red'}
                                                  text={'Cancel'}
                                                  disabled={sending}
                                                  onClick={hideModal}/>
                                <div style={{width: 10}}/>
                                <FatOutlineButton type="submit" disabled={sending} text={"Submit"} color={"green"}/>
                            </div>
                        </div>
                    </form>
                </FormProvider>
            </div>
        </div>
    );
}